module.exports = __webpack_public_path__ + "img/kefu.4ef049da.jpg";